exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-service-user-container[data-v-5e1a3f3c]{margin:12px 0}.button[data-v-5e1a3f3c]{width:80px}", ""]);

// exports
